import React from 'react'
import CardBox from '../../../common/card/CardBox'

const GroupStats = ({groupStats}) => {

    const data = [
        {
            count: groupStats.user_count ?? 0,
            label: "users",
            labelSingular: 'user'
        },
        {
            count: groupStats.course_count ?? 0,
            label: "courses",
            labelSingular: 'course'
        }
    ];

    return (
        <>
            <div className="msync-flex msync-flex--wrap">
                {
                    data.map((val, key) => {
                        return (
                            <CardBox props={ val } key={ key }/>
                        )
                    })
                }
            </div>
        </>
    )
}

export default GroupStats